module.exports = new __parcel__URL__("i-robot.9f758afc.jpg").toString();